import { Collapsible_Panel_default } from "./chunk-ERAJWWII.js";
import { Collapsible_default } from "./chunk-5KMA434Y.js";
import { Collapsible_Header_default } from "./chunk-ZJVHKJ3W.js";
import { Collapsible_Button_default } from "./chunk-VX7XXR6L.js";

// src/components/Collapsible/index.ts
var CollapsibleComponent = Collapsible_default;
CollapsibleComponent.Header = Collapsible_Header_default;
CollapsibleComponent.Header.displayName = "Collapsible.Header";
CollapsibleComponent.Panel = Collapsible_Panel_default;
CollapsibleComponent.Panel.displayName = "Collapsible.Panel";
CollapsibleComponent.Button = Collapsible_Button_default;
CollapsibleComponent.Button.displayName = "Collapsible.Button";
export { CollapsibleComponent };